export const isSuperAdmin = (state) => (state?.account?.role === 'SuperAdmin');
export const isAdmin = (state) => (state?.account?.role === 'SuperAdmin' || state?.account?.role === 'Admin');
export const isBooking = (state) => (state?.account?.role === 'SuperAdmin' || state?.account?.role === 'Admin' || state?.account?.role === 'Booking');
